export default __webpack_public_path__ + "static/media/SortDesc.9a3b2a1c.svg";